<template src="./index.html"></template>
<script>
import {getdata} from "./data.js";
import { iinv_fetchBillDetails, syncDeductInvoiceInfo } from '../../../../../api/iinv.js';
import config from "../../../../../../configHttp.js";
import { syncInvoiceInfo } from '@/api/xxzzs';
import { kydkpz_queryCompanyList } from '@/api/kydkpz';
import { deleteBatchAutoLog, queryGatewayInfo } from '@/api/organization';
import bsdl from '@/components/common/bsdl/index.vue';
// import { Select } from 'element-ui';
export default {
  name: "billdetails",
  components: { bsdl },
  data: function () {
    return {
      searchdata: getdata().searchdata,
      searchlist: getdata().searchlist,
      searchdiag: false,
      outlist: [],
      headData: getdata().headData,
      shaidiag: false,
      tableData: [],
      pagination: getdata().pagination,
      tablekey: 0,
        options:[],
        companyCode: "",
        drawer: false,
        rpaFormData:{},
        logId:0,
      overlength: 0,
        dialogDeductFormVisible: false,
        dialogFormVisible: false,
        syncDeductForm:getdata().syncFormDeductDefault,
        syncForm:getdata().syncFormDefault,
        formLabelWidth: '120px',
        invoiceStatus: [
            {
                label: "全部",
                value: "ALL"
            },
            {
                label: "正常",
                value: "NORMAL"
            },
            {
                label: "已作废",
                value: "VOID"
            },
            {
                label: "部分红冲",
                value: "PARTIAL_RED"
            },
            {
                label: "全额红冲",
                value: "FULL_RED"
            }
        ],
    };
  },
  created() {
    this.fetchBillDetails();
  },
  mounted() {},
  methods: {	  geOoverLength(e){
		  this.overlength = e;
		 
	  },
      submitDeductSync() {
          if (!this.syncDeductForm.issueDate || this.syncDeductForm.issueDate.length === 0) {
              this.$message.error("请选择开票日期")
              return;
          }
          this.syncDeductForm.issueStart = this.syncDeductForm.issueDate[0];
          this.syncDeductForm.issueEnd = this.syncDeductForm.issueDate[1];
          this.syncDeductForm.step = 7; // 当前步骤
          let companyId = this.syncDeductForm.companyId;
          syncDeductInvoiceInfo(this.syncDeductForm).then(res => {
              if (res.data.code === "1"){
                  this.$message.success("已提交同步任务，请稍后再进行查询")
              } else if (res.data.code === "102") {
                  // 需要登录
                  this.$confirm('同步失败，RPA未登录，点击确认进行登录', '提示', {
                      confirmButtonText: '确定',
                      cancelButtonText: '取消', // TODO 取消按钮需要删除任务
                      type: 'warning'
                  }).then(() => {
                      queryGatewayInfo({companyId: companyId}).then(gatewayRes => {
                          if (gatewayRes.data.code === 1) {
                              this.logId = res.data.data;
                              this.rpaFormData = gatewayRes.data.data[0];
                              this.drawer = true;
                          }
                      })
                  }).catch(()=>{
                      deleteBatchAutoLog({id: res.data.data}).then(autoLogRes=>{})
                  });
              } else {
                  this.$message.error("提交任务失败，原因：" + res.data.msg);
              }
              this.closeDeductDialog();
          })
      },
      submitSync() {
          if (!this.syncForm.issueDate || this.syncForm.issueDate.length === 0) {
              this.$message.error("请选择开票日期")
              return;
          }/*
          if (!this.syncForm.invoiceType) {
              this.$message.error("请选择发票类型")
              return;
          }*/
          if (!this.syncForm.invoiceStatus) {
              this.$message.error("请选择发票状态")
              return;
          }
          this.syncForm.issueStart = this.syncForm.issueDate[0];
          this.syncForm.issueEnd = this.syncForm.issueDate[1];
          this.syncForm.invoiceType = "INPUT";
          this.syncForm.step = 6; // 当前步骤
          let companyId = this.syncForm.companyId;
          syncInvoiceInfo(this.syncForm).then(res => {
              if (res.data.code === "1"){
                  this.$message.success("已提交同步任务，请稍后再进行查询")
              } else if (res.data.code === "102") {
                  // 需要登录
                  this.$confirm('同步失败，RPA未登录，点击确认进行登录', '提示', {
                      confirmButtonText: '确定',
                      cancelButtonText: '取消',
                      type: 'warning'
                  }).then(() => {
                      queryGatewayInfo({companyId: companyId}).then(gatewayRes => {
                          if (gatewayRes.data.code === 1) {
                              this.logId = res.data.data;
                              this.rpaFormData = gatewayRes.data.data[0];
                              this.drawer = true;
                          }
                      })
                  }).catch(()=>{
                      deleteBatchAutoLog({id: res.data.data}).then(autoLogRes=>{})
                  });
              } else {
                  this.$message.error("提交任务失败，原因：" + res.data.msg);
              }
              this.closedialog();
          })
      },
      syncDeductData() {
          this.dialogDeductFormVisible = true
      },
      syncData() {
          this.dialogFormVisible = true
      },
      smsClose() {
          this.drawer = false;
      },
      closeDeductDialog() {
          this.dialogDeductFormVisible = false;
          this.syncDeductForm = getdata().syncFormDefault
      },
      closedialog() {
          this.dialogFormVisible = false;
          this.syncForm = getdata().syncFormDefault
      },
    sizechange(e) {
      this.pagination.pageSize = e;
      this.fetchBillDetails();
    },
    currentChange(e) {
      this.pagination.pageNum = e;
      this.fetchBillDetails();
    },
    submitSearch() {
      this.pagination.pageNum = 1;
      this.pagination.paginationkey++;
      this.fetchBillDetails();
    },
    forRefresh() {
      this.pagination.pageNum = 1;
      this.pagination.paginationkey++;
      this.fetchBillDetails();
    },
    forUpdateSearch() {
      this.searchdiag = true;
    },
    closeSearch() {
      this.searchdiag = false;
    },
    saveChange(e) {
      this.searchdiag = false;
    },
    confirmfilter(e) {
      this.headData = e.chooselist;
      this.outlist = e.nochooselist;
      this.shaidiag = false;
    },
    closeshaidiag() {
      this.shaidiag = false;
    },

    // 加载票据明细信息
    fetchBillDetails() {
      let search = JSON.parse(JSON.stringify(this.searchdata))
      let params = JSON.parse(JSON.stringify(this.searchdata))
       	params.current = this.pagination.pageNum
       	params.size = this.pagination.pageSize
      params.sort = ""
      params.order =""
      params.search = search;
       	iinv_fetchBillDetails(params).then(res => {
       		this.pagination.total = res.data.data.total
       		this.tableData = res.data.data.records
       	})
        kydkpz_queryCompanyList().then(res => {
            if (res.data.code === 1) {
                let _data = res.data.data.map(v => {
                    return {
                        value: v.id,
                        label: v.nsrmc
                    };
                });
                this.options.push(..._data);
            } else {
                this.$message.error(res.data.msg);
            }
        });
    },

    // 导出进项明细发票合计结果
    outPutIInvResult() {
      let selectVal = this.$refs.tablebox.getSelectionval();
      if (selectVal.length == 0) {
        this.$message.info("请选中数据再进行导出操作");
        return;
      }
      let ids = new Array(selectVal.length);
      selectVal.forEach((v, k) => {
        ids[k] = v.id;
      });
      let params = {
        downUrl: config.baseURL + "/iinv/details/export",
        typeObj: {
          toForm: false,
          fileName: "进项增值税票据明细" + this.$timestampToStr(new Date(), "yyyyMMdd"),
          fileType: "xlsx",
          failUrl:this.$winURl
        },
        params: {
          exportType: this.exportType,
          suosq: this.dateValue,
          ids,
        },
      };
      this.$downloadcommon(params);
    },
  },
};
</script>

<style scoped lang="less">
@import url("./index.less");
</style>
